import fetch from 'cross-fetch'

export const CLEAR_ERROR = 'CLEAR_ERROR'
export const clearError = () => ({
    type: CLEAR_ERROR
});

export const REQUEST_PBN = 'REQUEST_PBN'
export const requestPBN = (gameType, game, table, board) => ({
    type: REQUEST_PBN,
    gameType: gameType,
    game: game,
    table: table,
    board: board
});

export const RECEIVE_PBN = 'RECEIVE_PBN'
export const receivePBN = (gameType, game, table, board, pbnData) => ({
    type: RECEIVE_PBN,
    gameType: gameType,
    game: game,
    table: table,
    board: board,
    pbnData: pbnData
});

export const ERROR_PBN = 'ERROR_PBN'
export const errorPBN = (gameType, game, table, board, error) => ({
    type: ERROR_PBN,
    gameType: gameType,
    game: game,
    table: table,
    board: board,
    error: error
});

export function fetchPBN(gameType, game, table, board) {

    return function(dispatch) {
        dispatch(requestPBN(gameType, game, table, board));

        return fetch("https://game.ultimate-bridge.com/tableBoard?type=" + gameType + "&game=" + game + "&table=" + table + "&board=" + board, { mode: 'no-cors' })
        // return fetch("http://localhost:8080/tableBoard?type=" + gameType + "&game=" + game + "&table=" + table + "&board=" + board, { mode: 'no-cors' })
            .then(
                response => {
                    if (response.ok) {
                        return response.json().then(
                            pbnObject => dispatch(receivePBN(gameType, game, table, board, pbnObject))
                        );
                    }

                    return response.json().then(
                        error => dispatch(errorPBN(gameType, game, table, board, error.error))
                    );
                },
                // Do not use catch, because that will also catch
                // any errors in the dispatch and resulting render,
                // causing a loop of 'Unexpected batch number' errors.
                // https://github.com/facebook/react/issues/6895
                error => {
                    return dispatch(errorPBN(gameType, game, table, board, {message: error.message}));
                }
            )};

}

export const PREVIOUS_AUCTION = 'PREVIOUS_AUCTION'
export const previousAuction = () => ({
    type: PREVIOUS_AUCTION
});

export const NEXT_AUCTION = 'NEXT_AUCTION'
export const nextAuction = () => ({
    type: NEXT_AUCTION
});

export const SHOW_AUCTION = 'SHOW_AUCTION'
export const showAuction = () => ({
    type: SHOW_AUCTION
});

export const RESET_AUCTION = 'RESET_AUCTION'
export const resetAuction = () => ({
    type: RESET_AUCTION
});

export const PLAY_CARD = 'PLAY_CARD'
export const playCard = () => ({
    type: PLAY_CARD
});

export const RESET_CARDS = 'RESET_CARDS'
export const resetCards = () => ({
    type: RESET_CARDS
});
